// Central SEO keyword bank for MoversNearby (Melbourne removalists)
const SITE = "https://moversnearby.com.au";

// Core keywords applied site-wide (service + intent + brand)
export const CORE_KEYWORDS = [
  "removalists melbourne", "movers melbourne", "removalists near me", "movers near me",
  "removalist near me", "removals near me", "moving company near me", "removal service near me",
  "removals", "cheap removals", "cheap movers", "cheap removalists", "removal company",
  "moving company melbourne", "removal company melbourne", "removalist melbourne",
  "cheap removalists melbourne", "affordable removalists melbourne", "best removalists melbourne",
  "professional removalists melbourne", "furniture removalists melbourne", "house movers melbourne",
  "office movers melbourne", "local removalists melbourne", "interstate removalists melbourne",
  "man with a van melbourne", "two men and a truck melbourne", "backloading removalists",
  "packing services melbourne", "moving services melbourne", "book removalists online",
  "moving quote melbourne", "hourly removalists melbourne", "furniture removal melbourne",
  "apartment movers melbourne", "unit removalists melbourne", "same day removalists melbourne",
];

// Major Melbourne suburbs/regions for local-intent coverage
export const SUBURB_KEYWORDS = [
  "removalists melbourne cbd", "removalists southbank", "removalists docklands",
  "removalists richmond", "removalists st kilda", "removalists brunswick",
  "removalists footscray", "removalists werribee", "removalists point cook",
  "removalists dandenong", "removalists frankston", "removalists box hill",
  "removalists glen waverley", "removalists preston", "removalists essendon",
  "removalists sunshine", "removalists craigieburn", "removalists cranbourne",
  "removalists pakenham", "removalists ringwood", "removalists geelong",
];

const kw = (arr) => arr.join(", ");

export const PAGE_SEO = {
  home: {
    title: "Removalists Melbourne | MoversNearby — House & Office Moves from $69/hr",
    description:
      "MoversNearby are trusted removalists in Melbourne. House moves, office relocations, furniture removal & packing from $69/hr. Fully insured local crews. Book online or get a free quote.",
    keywords: kw([...CORE_KEYWORDS, ...SUBURB_KEYWORDS]),
    path: "/",
  },
  pricing: {
    title: "Removalist Prices Melbourne | Hourly Rates from $69/hr — MoversNearby",
    description:
      "Transparent removalist pricing in Melbourne. Small, medium & large trucks with honest hourly rates from $69/hr, no hidden fees. See prices and book your move online.",
    keywords: kw([
      "removalist prices melbourne", "removalist rates melbourne", "hourly removalists melbourne",
      "cheap removalists melbourne", "removalist cost melbourne", "truck hire with movers melbourne",
      ...CORE_KEYWORDS,
    ]),
    path: "/pricing",
  },
  faq: {
    title: "Removalists Melbourne FAQ | Costs, Insurance & Booking — MoversNearby",
    description:
      "Common questions about moving in Melbourne — removalist costs, insurance, same-day moves, interstate moving and how to get a free quote with MoversNearby.",
    keywords: kw([
      "removalist faq melbourne", "how much do removalists cost melbourne", "removalist insurance",
      "same day removalists melbourne", "interstate removalists melbourne", ...CORE_KEYWORDS,
    ]),
    path: "/faq",
  },
  contact: {
    title: "Contact MoversNearby | Removalists Melbourne — Call 03 9113 6005",
    description:
      "Get in touch with MoversNearby for removals across Melbourne. Call 03 9113 6005 or request a free moving quote online for house, office and interstate moves.",
    keywords: kw([
      "contact removalists melbourne", "removalists phone number melbourne", "moving quote melbourne",
      "free removalist quote melbourne", ...CORE_KEYWORDS,
    ]),
    path: "/contact",
  },
  trucks: {
    title: "Moving Trucks Melbourne | 3, 6 & 10 Tonne Removal Trucks — MoversNearby",
    description:
      "Our Melbourne moving fleet — small, medium and large removal trucks fully equipped with blankets, trolleys and straps for safe house and office moves.",
    keywords: kw([
      "moving trucks melbourne", "removal truck hire melbourne", "3 tonne truck", "6 tonne truck",
      "10 tonne truck", "furniture truck melbourne", ...CORE_KEYWORDS,
    ]),
    path: "/trucks",
  },
};

export function serviceSeo(service) {
  const base = service.title;
  const extra = {
    "house-movers-melbourne": ["house removals melbourne", "home movers melbourne", "residential removalists melbourne"],
    "local-removalists-melbourne": ["local movers melbourne", "suburb to suburb removalists", "local moving company melbourne"],
    "apartment-unit-removalists": ["apartment removalists melbourne", "unit movers melbourne", "high rise removalists melbourne"],
    "furniture-removal-melbourne": ["furniture removal melbourne", "single item removalists", "sofa & bed removalists melbourne"],
    "office-moving-relocation": ["office removalists melbourne", "commercial movers melbourne", "business relocation melbourne"],
    "interstate-removalists": ["interstate removalists melbourne", "melbourne to sydney removalists", "melbourne to brisbane removalists", "backloading interstate"],
    "packing-services": ["packing services melbourne", "professional packers melbourne", "moving boxes & packing melbourne"],
  }[service.slug] || [];
  return {
    title: `${base} | MoversNearby Removalists Melbourne`,
    description:
      `${base} with MoversNearby — professional, fully insured Melbourne removalists from $69/hr. ${service.paragraphs?.[0] || ""}`.slice(0, 300),
    keywords: kw([...extra, ...CORE_KEYWORDS]),
    path: `/services/${service.slug}`,
  };
}

export { SITE };

export function suburbSeo(name, slug) {
  return {
    title: `Removalists ${name} | Cheap Movers Near You from $69/hr — MoversNearby`,
    description:
      `Local removalists in ${name}. MoversNearby are your cheap, reliable movers near you for house moves, furniture removals & office relocations from $69/hr. Fully insured. Get a free ${name} moving quote or book online.`,
    keywords: kw([
      `removalists ${name.toLowerCase()}`, `movers ${name.toLowerCase()}`,
      `cheap removalists ${name.toLowerCase()}`, `removals ${name.toLowerCase()}`,
      `house movers ${name.toLowerCase()}`, `furniture removalists ${name.toLowerCase()}`,
      `${name.toLowerCase()} removalists near me`, `movers near me`, `removalist near me`,
      `cheap removals`, `cheap movers`, `removals near me`, ...CORE_KEYWORDS,
    ]),
    path: `/removalists/${slug}`,
  };
}
